export const extractMarkdown = (field?: Markdown | string) => {
  if (typeof field === 'string') {
    return field;
  }

  const { data } = field || {};

  return wrapLiContentWithSpan(data?.childMarkdownRemark?.html || '');
};

/**
 * Process images in HTML to add error handling and better styling
 * @param htmlString - the HTML string to be processed
 * @returns a new HTML string with processed images
 */
const processImagesInHtml = (htmlString: string): string => {
  // TODO: fix mismatch with server
  if (typeof window === 'undefined') {
    return htmlString;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const images = doc.querySelectorAll('img');

  images.forEach((img) => {
    // Add error handling classes and attributes
    img.classList.add('article-image');
    img.setAttribute('loading', 'lazy');
    
    // Add error handling
    img.addEventListener('error', function() {
      this.style.display = 'none';
      // Create a fallback element
      const fallback = doc.createElement('div');
      fallback.className = 'image-error-fallback';
      fallback.innerHTML = `
        <div class="image-error-container">
          <div class="image-error-icon">📷</div>
          <p class="image-error-text">Image non disponible</p>
        </div>
      `;
      this.parentNode?.insertBefore(fallback, this.nextSibling);
    });
  });

  return doc.body.innerHTML;
};

/**
 *  Wraps the content of each <li> element in a given HTML string with a <span> with specific class attributes
 *  Allows to have a single tag for styling
 *
 *  @param htmlString - the HTML string to be processed
 *  @returns a new HTML string with <li> contents wrapped in a <span>
 */
const wrapLiContentWithSpan = (htmlString: string): string => {
  // TODO: fix mismatch with server
  if (typeof window === 'undefined') {
    return htmlString;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const listItems = doc.querySelectorAll('li');

  listItems.forEach((li) => {
    const span = doc.createElement('span');

    // Move the existing contents of <li> into the <span>
    while (li.firstChild) {
      span.appendChild(li.firstChild);
    }

    // Append the <span> to the <li>
    li.appendChild(span);
  });

  return doc.body.innerHTML;
};
